<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <div v-if="loading || Object.keys(Transaction).length === 0" >
      <b-card v-for="n in 4" :key="n">
        <b-skeleton width="100%" height="400px"></b-skeleton>
          
      </b-card>

    </div>
    <div v-else>
      <b-card >
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
           معلومات المعاملة
          </h3>
        </div>
        <hr />
        <b-row>
          <b-col md="4" cols="12">
            <info-card
              label="معرف المعاملة"
              :value="Transaction.id"
            />
            
          </b-col>
          <b-col md="4" cols="12">
            <info-card
              label="نوع المعاملة"
              :value="Transaction.transactionType.name"
            />
          </b-col>
          <b-col md="4" cols="12">
              <b-card class="profile-header">
                <div class="info-card w-100 px-2 py-1">
                    <h6
                    style="width: fit-content; padding: 4px 6px; margin-bottom: 6px;"
                    class="bg-info rounded text-white font-weight-bold"
                    >
                    حالة المعاملة 
                    </h6>
                    <transactions-status-formatter :value="Transaction.status" />
                    <hr />
                </div>

              </b-card>
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="تاريخ تقديم المعاملة" :value="$moment(Transaction.created_at).format(`YYYY-MM-DD`)"  />
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="تاريخ أخر تعديل على المعاملة" :value="$moment(Transaction.updated_at).format(`YYYY-MM-DD`)"   />
          </b-col>
          <b-col md="4" cols="12"  v-if="tab!=='announcements'">
            <info-card label="التاريخ اللازم للبدء في المعاملة" :value="Transaction.start_date" />
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="التاريخ اللازم للإنتهاء من تدقيق المعاملة" :value="Transaction.end_date" />
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="Transaction.transactionType.slug !== 'establishing_ngo'">
        
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            معلومات الجهة المقدمة للمعاملة 
          </h3>
        </div>
        <hr />
        <show-transaction-provider :ngo="Transaction.ngo" :user="Transaction.user"></show-transaction-provider>
        
      </b-card>
      <b-card  v-if="Object.keys(form).length >0">
        
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            بيانات المعاملة
          </h3>
        </div>
        <hr />
        <component :is="getComponentName(Transaction.transactionType.slug)"
          :data="form"
          :url="Transaction.transactionType.slug === 'logo_approval' ? Transaction.transactionRequestData[0].field_value : null"
        />
      </b-card>
      <b-card v-if="tab!=='announcements'">
        
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            سير المعاملة
          </h3>
        </div>
        <hr />
        
        <show-transaction-flow :actionHistories="Transaction.actionHistories" :is-ngo="false"></show-transaction-flow>  
      </b-card>
        <b-button v-if="ifChechingButtonActivated && (tab==='under_checking' || tab==='returned_from_higher_level')" variant="success" size="lg"  class="advanced-report" @click="onClickedChecking">
          
          <feather-icon size="20" icon="FileIcon" /> 
          <span>
             إعتماد / إرسال 
          </span>
        </b-button>

      
    
      <b-modal
        v-model="checkTransiction"
        footer-class="removed"
        centered
        no-close-on-backdrop
        v-bind="$attrs"
        v-on="$listeners"
        title="تدقيق معاملة"
      >
        <div>
          <div>
            هل تريد مصادقة أم إستدراك المعاملة ؟
          </div>
        </div>
        <hr/>

        <div class="d-flex justify-content-end">
          <b-button
            variant="danger"
            class="mx-1"
            @click="onClickedRejectTractation()"
          >
            <feather-icon icon="XIcon" />
            رفض 
          </b-button>

          <b-button
            type="submit"
            variant="secondary"
            class="mx-1"
            @click="onClickedReTractation()"
          >
            <feather-icon icon="EditIcon" />
            استدراك
            
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="mx-1"
            @click="onClicked()"
          >
            <feather-icon icon="CheckIcon" />
            إعتماد / إرسال
            
          </b-button>
        </div>

      </b-modal>
      <reply-modal 
        v-model="replyModal" 
        :loading="loadingStrating" 
        :mainTitle="formChangeStatus.status == 'need_correction'? 'سبب الإستدراك' : formChangeStatus.status == 'accepted'? 'مرفقات المصادقة' : 'سبب الرفض'" 
        :isHaveNote="formChangeStatus.status == 'need_correction'? true : formChangeStatus.status == 'accepted'? false : true" 
        :isLastAction="formChangeStatus.is_last_action == 1 ? true : false" 
        :isHaveCheck="Transaction.transactionType.slug == 'establishing_ngo'? true : false"
        :transactionSlug="Transaction.transactionType.slug"
        :status="formChangeStatus.status"
        :names="Transaction.transactionType.slug == 'establishing_ngo'? [Transaction.establishmentNgo.ngo_name , Transaction.establishmentNgo.fst_alt_ngo_name , Transaction.establishmentNgo.sec_alt_ngo_name] : []"
        @confirm="onClickedReject">
      </reply-modal>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BButton , VBTooltip , VBToggle ,   BImg, BAvatar, BMedia, BCollapse, BListGroup, BListGroupItem, BAvatarGroup, BBadge, BSkeleton , BModal} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { getModifiedTransactionData } from "@/modules/ngo/transactions/pages/transactions/utils";
import FormModal from "@/components/FormModal.vue";
import Ripple from 'vue-ripple-directive' ;
import loaderBtn from "@/components/loader-btn";
import ReplyModal from "../accreditation-transactions/components/ReplyModal.vue";
import {
  ShowLogo, ShowMeetings, ShowFounder, ShowCampaign, ShowBranch, ShowActivityFormModal, ShowTransactionProvider, ShowTransactionFlow,  ShowCollaboration, ShowFinancialGrant, ShowBoard, ShowInternalDonation, ShowExternalDonationModal, ShowMoneyTransfer,
   ShowHoldGeneralBodyMeeting, ShowDissolutionNGO, ShowInternationalEventsSubscription , ShowUnknownBranch , ShowJoiningInternationalNGO,
   ShowComplaintAndObjectionAgainstViolation,
   ShowModifyingInternalSystem,
   ShowMergingTwoNgos , ShowTempNgo
} from "@/modules/ngo/transactions/components";
import TransactionsStatusFormatter from "@/modules/ngo/transactions//components/TransactionsStatusFormatter.vue";
export default {
  props: ["id"],
  components: {
    ShowActivityFormModal,
    BRow, BCol, BCard, DataTable, MinistryBreadcrumbs, BButton, InfoCard , AppTimeline, AppTimelineItem, BImg, BAvatar, BMedia, BCollapse, BListGroup, BListGroupItem, BAvatarGroup, BBadge ,
    BSkeleton ,  ShowLogo, ShowMeetings , ShowFounder , ShowCampaign ,  ShowBranch , ShowTransactionProvider ,  ShowTransactionFlow ,  BModal ,  FormModal , loaderBtn ,
    ShowCollaboration ,  ShowFinancialGrant ,  ShowHoldGeneralBodyMeeting , ShowBoard , ShowInternalDonation , ShowExternalDonationModal , ShowMoneyTransfer , ShowDissolutionNGO , TransactionsStatusFormatter , ReplyModal, ShowInternationalEventsSubscription ,
    ShowUnknownBranch , ShowJoiningInternationalNGO,
    ShowComplaintAndObjectionAgainstViolation,
    ShowModifyingInternalSystem,
    ShowMergingTwoNgos , ShowTempNgo
  },
  async mounted() {
    await this.fetchTransactionById(this.$route.params.id);
    
    this.typeOfTransaction = this.Transaction.transactionType.slug 
    this.form = getModifiedTransactionData( this.typeOfTransaction , this.Transaction)
    if(this.tab!=='announcements')
    {
      this.setFormChangeStatus()
    }
  },

  computed: {
    ...mapGetters("Ministry/Settings/Transaction", ["Transaction" , "loading" , "loadingStrating"]),
    tab(){
      return localStorage.getItem("tab")
    }
  },
  methods: {
    ...mapActions("Ministry/Settings/Transaction", ["fetchTransactionById" , "startChecking" , "changeCurrentStage"]),
    getComponentName(typeOfTransaction) {
      switch (typeOfTransaction) {
        case 'logo_approval':
          return 'show-logo';
        case 'minutes_of_administrative_meetings':
          return 'show-meetings';
        case 'member_of_board_of_directors_or_Trustees':
          return 'show-founder';
        case 'fundraising_campaign':
          return 'show-campaign';
        case 'open_office':
          return 'show-branch';
        case 'annual_plan_approval':
          return 'show-activity-form-modal';
        case 'collaboration_two_local_partners':
          return 'show-collaboration';
        case 'financial_grant_request':
          return 'show-financial-grant';
        case 'hold_general_body_meeting':
          return 'show-hold-general-body-meeting';
        case 'hold_general_body_meeting_2':
          return 'show-hold-general-body-meeting';
        case 'changing_the_board_of_directors_or_trustees':
          return 'show-board';
        case 'internal_donation':
          return 'show-internal-donation';
        case 'international_donations':
          return 'show-external-donation-modal';
        case 'international_events_subscriptions':
          return 'show-international-events-subscription'
        case 'transfer_money_abroads': 
          return 'Show-money-transfer'
        case 'dissolution_of_an_NGO': 
          return 'show-dissolution-nGO'
        case 'un_known_branch':
          return 'show-unknown-branch'
        case 'membership_application_to_international_organization':
          return 'show-joining-international-nGO'
        case 'complaint_and_objection_against_violation':
          return 'show-complaint-and-objection-against-violation'
        case 'internal_system_modification_requests':
          return 'show-modifying-internal-system'
        case 'merging_two_ngos':
          return 'show-merging-two-ngos'
          case 'establishing_ngo':
          return 'show-temp-ngo'
        default:
          return ''; // Define a default component if needed
      }
    },
    onClickedReTractation() {
      this.checkTransiction = false
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من إنك تريد استدراك معلومات المعاملة ؟", {
          title: "تأكيد استدراك معلومات المعاملة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.replyModal = true;
            this.formChangeStatus.status = 'need_correction';
            this.formChangeStatus.action_number = this.Transaction.action_number - 1
          }
        });
    },
    onClickedRejectTractation(){
      this.checkTransiction = false
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من إنك تريد  رفض المعاملة ؟", {
          title: "تأكيد رفض المعاملة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.replyModal = true;
            this.formChangeStatus.status = 'rejected';
          }
        });
    },
    onClickedStaring(){
      this.startChecking({id: this.$route.params.id , data: this.formChangeStatus})
        .then(async() => {
          
          await this.fetchTransactionById(this.$route.params.id);
          this.setFormChangeStatus()
          this.ifChechingButtonActivated = false
          this.ifReceiveButtonActivated = false
          this.ifShowReplyButtonActivated = false
          this.checkTransiction = false
        });
    },
    onClickedShowReply(){
      this.replyModal = true
      this.$refs.replyModal.init({notes : this.feedbackContent});
    },
    onClickedChecking(){
      this.checkTransiction = true
      
    }, 
    setFormChangeStatus(){
      let actionHistoriesSorted = this.Transaction.actionHistories
      // let curentAction = this.Transaction.actionHistories.find(obj => obj.action_order === action_number) || this.Transaction.actionHistories.find(obj => obj.action_order === 1)
   
      let lastActionNotWating = this.Transaction.actionHistories.slice().reverse().find(obj => obj.status !== 'waiting')
      let index =  this.Transaction.actionHistories.slice().reverse().findIndex(obj => obj.status !== 'waiting')
      let firstActionWating = actionHistoriesSorted.find(obj => obj.status === 'waiting')
      let firstActionOpen = actionHistoriesSorted.find(obj => obj.status === 'open')
      this.formChangeStatus.tab = this.tab
      // let action_id = null
      if(lastActionNotWating === undefined)
      {
        //  ما لاقى ولا واحد حالتو ما لها  قيد الإنتظار  معناها لازم يجيب أول إجراء و يعملها فتح
        this.ifReceiveButtonActivated = true 
        this.formChangeStatus.action_id = firstActionWating.id 
        this.formChangeStatus.status = 'open'
        if(this.Transaction.action_number){
          this.formChangeStatus.action_number = this.Transaction.action_number+1 
        }
        else{
          this.formChangeStatus.action_number = 1

        }

      }
      else {
        // معناها لاقى أجراء حالتو مو قيد الانتظار 
        // لح يفحص أذا مفتوح لح يكون في إمكانية للتعقيب أز أذا كمان بحاجة استدراك ف لح يكون في إمكانية للتعقيب  
        // || 
        if (firstActionOpen.status === 'open'  ){
          // التحقق فيما إذا كان المستخدم الحالي هو ذاته المفتوحة عنده و يملك نفس الدور و ليس مطلوب استدراكها من المنظمة
         console.log("firstActionOpen.actionMinistryUserHistories[firstActionOpen.actionMinistryUserHistories.length-1].ministryUser.id" , firstActionOpen.actionMinistryUserHistories[firstActionOpen.actionMinistryUserHistories.length-1].ministryUser.id)
         console.log("JSON.parse(localStorage.getItem(user)).id" , JSON.parse(localStorage.getItem("user")).id)
         console.log("firstActionOpen.actionType.transactionRole.slug" , firstActionOpen.actionType.transactionRole.slug)
         console.log('localStorage.getItem("typeOfRole") ' , localStorage.getItem("typeOfRole") )
          if(firstActionOpen.actionMinistryUserHistories[firstActionOpen.actionMinistryUserHistories.length-1].ministryUser.id === JSON.parse(localStorage.getItem("user")).id && firstActionOpen.actionType.transactionRole.slug === localStorage.getItem("typeOfRole")  && this.Transaction.action_number !==0){
            this.ifChechingButtonActivated = true 
          }
          this.formChangeStatus.action_id = firstActionOpen.id 
          if(this.Transaction.actionHistories.filter(obj => obj['version_number'] === null).length===this.Transaction.action_number){
            this.formChangeStatus.action_number = this.Transaction.action_number
            this.formChangeStatus.is_last_action = 1
          }
          else{
            this.formChangeStatus.action_number = this.Transaction.action_number+1
            this.formChangeStatus.is_last_action = 0
          }

        }
        else if (lastActionNotWating.status === 'open'  ){
          // التحقق فيما إذا كان المستخدم الحالي هو ذاته المفتوحة عنده و يملك نفس الدور و ليس مطلوب استدراكها من المنظمة
          if(lastActionNotWating.actionMinistryUserHistories[firstActionOpen.actionMinistryUserHistories.length-1].ministryUser.id === JSON.parse(localStorage.getItem("user")).id && lastActionNotWating.actionType.transactionRole.slug === localStorage.getItem("typeOfRole")  && this.Transaction.action_number !==0){
            this.ifChechingButtonActivated = true 
          }
          this.formChangeStatus.action_id = lastActionNotWating.id 
          if(this.Transaction.actionHistories.filter(obj => obj['version_number'] === null).length===this.Transaction.action_number){
            this.formChangeStatus.action_number = this.Transaction.action_number
            this.formChangeStatus.is_last_action = 1
          }
          else{
            this.formChangeStatus.action_number = this.Transaction.action_number+1
            this.formChangeStatus.is_last_action = 0
          }

        }
        else if (lastActionNotWating.status === 'need_correction' ){
          let lastActionNotNeedCorrection = this.Transaction.actionHistories.slice().reverse().find(obj => obj.status !== 'need_correction')
          // التحقق فيما إذا كان المستخدم الحالي هو ذاته المفتوحة عنده و يملك نفس الدور و ليس مطلوب استدراكها من المنظمة
          if(lastActionNotWating.actionMinistryUserHistories[firstActionOpen.actionMinistryUserHistories.length-1].ministryUser.id === JSON.parse(localStorage.getItem("user")).id && lastActionNotWating.actionType.transactionRole.slug == localStorage.getItem("typeOfRole") && this.Transaction.action_number !==0){
            this.ifChechingButtonActivated = true 
          }
          this.formChangeStatus.action_id = lastActionNotNeedCorrection.id 
          this.feedbackContent = lastActionNotWating.notes
            this.formChangeStatus.is_last_action = 0
          this.formChangeStatus.action_number = this.Transaction.action_number - 1
          // this.formChangeStatus.action_number = this.Transaction.action_number

        }
        else{
        //   معناها هي مقبولة 
        // فلح يجيب أول إجراء حالتو قيد النتظار مشان يعملو فتح   
        this.ifReceiveButtonActivated = true 
        if(firstActionWating){

          this.formChangeStatus.action_id = firstActionWating.id 
        }
        this.formChangeStatus.is_last_action = 0
        this.formChangeStatus.status = 'open'
        if(this.Transaction.action_number){
          this.formChangeStatus.action_number = this.Transaction.action_number+1 
        }
        else{
          this.formChangeStatus.action_number = 1

        }
      
        }
      }
      let x = localStorage.getItem("typeOfRole")
      this.formChangeStatus.MU_transaction_role_id = JSON.parse(localStorage.getItem('user')).transactionRoles.find(obj => obj.slug === x).id
    },
    onClicked(){
      this.formChangeStatus.status = 'accepted'
      this.replyModal = true
      
    }, 
    onClickedAdd(form){
      if(!form.hasOwnProperty('data') || Object.keys(form.data).length === 0 ){
    
        form.data =[{}]
      }
      else{
        
        // check if any form station => open without save Data
        let i=0
        if(form.data.length === 0)
        {
          form.data.push({})
        }
        
        else{
          for(let item of form.data)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              form.data.splice(i-1, 1) 
            }
        
        
          }
          form.data.push({})
        }

      

      }
    },
    onClickedReject(form){
      if(form.hasOwnProperty('files')){

        this.formChangeStatus.files = form.files
      }
      if(form.hasOwnProperty('accepted_ngo_name_for_establishing_ngo')){

        this.formChangeStatus.accepted_ngo_name_for_establishing_ngo = form.accepted_ngo_name_for_establishing_ngo
      }
      if(form.hasOwnProperty('extra_data')){

        this.formChangeStatus.extra_data = form.extra_data
      }
      if(form.hasOwnProperty('decision_no_for_establishing_ngo')){

        this.formChangeStatus.decision_no_for_establishing_ngo = form.decision_no_for_establishing_ngo
      }
      if(form.hasOwnProperty('decision_date_for_establishing_ngo')){

        this.formChangeStatus.decision_date_for_establishing_ngo = form.decision_date_for_establishing_ngo
      }
      if(form.hasOwnProperty('decision_file_for_establishing_ngo')){

        this.formChangeStatus.decision_file_for_establishing_ngo = form.decision_file_for_establishing_ngo
      }
      this.formChangeStatus.notes = form.notes
      this.startChecking({id: this.$route.params.id ,  data: this.formChangeStatus })
        .then(async() => {
          this.checkTransiction = false
          this.replyModal = false
          this.ifChechingButtonActivated = false
          this.ifReceiveButtonActivated = false
          this.ifShowReplyButtonActivated = false
          await this.fetchTransactionById(this.$route.params.id);
          if(this.Transaction.transactionType.slug=== 'establishing_ngo'){
            if( this.formChangeStatus.action_id = this.Transaction.actionHistories.filter(item => item['version_number'] == null)[0].id){
             
              if(this.formChangeStatus.status ==='need_correction' && this.formChangeStatus.action_number == 0){

                await this.changeCurrentStage({ finished_stage_number: 6 , id:this.Transaction.establishmentNgo.id});
              }
            }
          }
        });
      
    }, 
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      mainTitle: "إدارة المعاملات",
      checkTransiction : false ,
      replyModal : false ,
      ifReceiveButtonActivated : false ,
      ifChechingButtonActivated : false ,
      ifShowReplyButtonActivated : false ,
      feedbackContent : null ,
      type: "ADD",
      ep: `v2/ministry/files-qrs/get-file-qr-logs/${this.id}`,
      replyFormSchema: {
        notes: {
          component: "FormTextarea",
          key: "notes",
          attrs: {
            label: "السبب",
          },
        },
        files: {
          key: "files",
          attrs: {
            label: "المرفقات",
          },
        },
      },
      form : {},
      typeOfTransaction : null ,
      formChangeStatus : {},
      fields: [
        { label: "المعرف", key: "id" },
        { label: "تاريخ المسح", key: "created_at" },
        { label: "وجهة الملف", key: "ngoFileQR.destination" },
        { label: "حالة المنظمة عند مسح الملف ", key: "ngoFileQR.destination" },
      ],
      breadcrumbs: [
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "تفاصيل معاملة",
          active: true,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.advanced-report {
  position: fixed;
  bottom: 6%;
  z-index: 1031;
  right: 1%;
}
.timeline-item {
  list-style: none;
}
</style>
